import React, { Component } from 'react';
import { getDmService } from '../../../services/Api';
import appConfig from '../../../config/app-config';

class ItensMerchandisig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentWillMount() {
    this.getProducts();
  }

  getProducts = async () => {
    try {
      const data = await getDmService('/Produto/BuscaPorTipo/?tipo=2');
      console.log(data);
      this.setState({
        data
      });
    } catch (error) {
      console.log(error)
    }
  };

  listItens() {
    const { data } = this.state;
    const { makeItem } = this.props;
    const { IMAGE_PATHV2 } = appConfig;
    return data.map(item => (
      <div onClick={() => makeItem(item)} key={item.id} className="bx--col-md-4">
        {item.imagem ? (
          <figure className="figure-img pointer" id={`itemImg${item.id}`}>
            <img
              id={`itemImg${item.id}`}
              className="img-responsive"
              alt={item.descricao}
              src={`${IMAGE_PATHV2}${item.imagem}`}

            />
            <figcaption className="mg-top-10">
              {' '}
              {item.nome}
              {' '}
            </figcaption>
          </figure>
        ) : (
          <div>
            <figure className="figure-img pointer" id={`itemImg${item.id}`}>
              <i className="material-icons not-imagem-product">image</i>
              <figcaption className="mg-top-10 text-center">
                {' '}
                {item.nome}
                {' '}
              </figcaption>
            </figure>            
           
          </div>
          )

        }

      </div>
    ));
  }

  render() {
    return <div className="bx--row galery-itens">{this.listItens()}</div>;
  }
}

export default ItensMerchandisig;



// WEBPACK FOOTER //
// ./src/components/trades/campaign/ItensMerchandisig.js